'use strict';
import $ from 'jquery';
import noop from 'lodash/noop';

export default (selector = '.list-progress-bar') => {
	const $progressBar = $(selector);
	if (!$progressBar.length) return noop;

	const { progress } = $progressBar.data();
	const $bar = $progressBar.find('> div');

	const setProgress = percentage => $bar.css('width', Math.ceil(percentage * 100) + '%');

	if (!isNaN(parseFloat(progress))) {
		setProgress(parseFloat(progress));
	}

	return {
		setProgress
	}
}
